var _desc, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2263,
    viewBox: "0 0 95 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(.17 30.901)",
    fill: "#EA6C00"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(-1 0 0 1 94.64 30.901)",
    fill: "#EA6C00"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(19.3 30.901)",
    fill: "#FDAD00"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "translate(19.3 .42)",
    fill: "#FDD231"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "matrix(-1 0 0 1 75.5 .42)",
    fill: "#FDD231"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "matrix(-1 0 0 1 94.64 3.234)",
    fill: "#FDAD00"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "translate(.17 3.234)",
    fill: "#FDAD00"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "translate(19.3 .42)",
    fill: "#FEEEB7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fillRule: "evenodd",
    d: "M19.131 0l28.1 55L0 0h19.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    fillRule: "evenodd",
    d: "M19.131 0l28.1 55L0 0h19.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    fillRule: "evenodd",
    d: "M0 0h56.2L28.1 55 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    fillRule: "evenodd",
    d: "M28.1 0L1.479 2.814 0 30.481 28.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    fillRule: "evenodd",
    d: "M28.1 0L1.479 2.814 0 30.481 28.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    fillRule: "evenodd",
    d: "M0 27.667L20.61 0l-1.479 27.667H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    fillRule: "evenodd",
    d: "M0 27.667L20.61 0l-1.479 27.667H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    fillRule: "evenodd",
    d: "M28.1 0L0 30.481h56.2L28.1 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.795112d9324eda2216c5bc2db04a3077.svg";
export { ForwardRef as ReactComponent };